import React, { isValidElement, cloneElement } from 'react'
import type { FC, HTMLAttributes, ReactElement, ReactNode } from 'react'
import styles from './form-control-label.module.css'

export interface FormControlLabelProps extends Omit<HTMLAttributes<HTMLLabelElement>, 'onChange'> {
  control: ReactNode
  label?: ReactNode
  disabled?: boolean
  value?: string | number
  labelPlacement?: 'end' | 'start' | 'top' | 'bottom'
}

const placementMap: Record<string, string | undefined> = {
  start: styles.start,
  top: styles.top,
  bottom: styles.bottom,
}

export const FormControlLabel: FC<FormControlLabelProps> = ({
  control,
  label,
  disabled,
  value,
  labelPlacement = 'end',
  className,
  style,
  ...rest
}) => {
  const classes = [
    styles.formControlLabel,
    placementMap[labelPlacement],
    className,
  ]
    .filter(Boolean)
    .join(' ')

  // Pass value and disabled to the control element (like MUI does)
  const controlElement =
    isValidElement(control)
      ? cloneElement(control as ReactElement<{ value?: string | number; disabled?: boolean }>, {
          ...(value != null ? { value } : undefined),
          ...(disabled != null ? { disabled } : undefined),
        })
      : control

  return (
    <label
      className={classes}
      style={disabled ? { opacity: 0.38, pointerEvents: 'none', ...style } : style}
      {...rest}
    >
      {controlElement}
      <span className={styles.labelText}>{label}</span>
    </label>
  )
}
